import { render, staticRenderFns } from "./layout.vue?vue&type=template&id=c098899a&scoped=true&"
import script from "./layout.vue?vue&type=script&lang=ts&"
export * from "./layout.vue?vue&type=script&lang=ts&"
import style0 from "./layout.vue?vue&type=style&index=0&id=c098899a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c098899a",
  null
  
)

export default component.exports